export class BackupEncryptionError extends Error {
  // This gives the error type safety
  private readonly typeName = 'BackupEncryptionError'
  public readonly name = this.typeName

  constructor(message: string) {
    super(`Error in the backup encryption: ${message}`)
  }
}
